<div class="flex flex-row">
  <div class="flex jcc">
    <label class="title">Group Thumbnail <span>(Need for HealthVU)</span></label>
    <div class="rel">
      <rx-button class="blue" (click)="updateThumb()">{{ value ? 'Delete' : 'Upload' }}</rx-button>
      <input
        type="file"
        (change)="selectFile($event)"
        name="file1"
        id="file1"
        class="inputfile"
        accept="image/*"
        *ngIf="!value"
      />
    </div>
  </div>
  <div>
    <div class="preview">
      <img [src]="value" *ngIf="value" />
    </div>
  </div>
</div>
